export default class CustomEventListener {
  constructor() {
    this.listenerList = [];
  }

  emit(event) {
    for (let i = 0; i < window.customEventListener.listenerList.length; i++) {
      const listener = window.customEventListener.listenerList[i];
      if (listener.event === event.type) {
        listener.callback.call(listener.context || this, event);
      }
    }
  }

  addEventListener(event, callback, key, context) {
    window.customEventListener.listenerList.push({
      event, callback, key, context,
    });
  }

  removeEventListener(event, key) {
    const index = window.customEventListener.listenerList.findIndex(i => event === i.event && key === i.key);
    if (index > -1) {
      window.customEventListener.listenerList.splice(index, 1);
    }
  }
}
